import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import {
    AppBar,
    Box,
    Card,
    CardMedia,
    Toolbar,
    Typography,
} from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    card: {
        boxShadow: 'none',
        position: 'relative',
        width: '100%',
        height: 120,
        borderRadius: 0,
    },
    cardProjectNote: { minWidth: 1910 },
    content: {
        position: 'absolute',
        zIndex: 2,
        bottom: 0,
        width: '100%',
        background:
            'linear-gradient(89.99deg, #FBB41F 0.01%, rgba(0, 0, 0, 0) 99.58%)',
        height: 35,
        display: 'flex',
        alignItems: 'center',
    },
    contentText: {
        fontSize: pxToRem(38),
        color: theme.palette.common.white,
    },
    media: {
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        position: 'absolute',
    },
    header: {
        background: 'linear-gradient(90.06deg, #5F788A 8.33%, #2F4858 83.33%)',
    },
    headerToolbar: {
        minHeight: 60,
    },
    headerText: {
        color: '#FFFFFF',
    },
}))

interface DialogAppBarProps {
    name: string
    BannerImageSrc?: string
}

export const DialogAppBar: React.FC<DialogAppBarProps> = ({
    name,
    BannerImageSrc,
}) => {
    const classes = useStyles()
    if (name === 'Notes') {
        return (
            <Card
                className={clsx(classes.card, classes.cardProjectNote)}
                data-testid="dvProjectImageCard"
            >
                <CardMedia
                    data-testid="projectImage"
                    className={classes.media}
                    image={BannerImageSrc}
                />
                <Box py={3} px={2} className={classes.content}>
                    <div className={classes.contentText}>{name}</div>
                </Box>
            </Card>
        )
    } else {
        return (
            <AppBar className={classes.header} position="static">
                <Toolbar variant="dense" className={classes.headerToolbar}>
                    <Typography
                        className={clsx('lblTitle', classes.headerText)}
                        variant="h1"
                        noWrap
                    >
                        {name}
                    </Typography>
                </Toolbar>
            </AppBar>
        )
    }
}
